// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-205f6387] .ant-form-item-children {\n  width: 80%;\n}", ""]);
// Exports
module.exports = exports;
